import { isFinanceProject, isGlobalProject } from 'config';

import { ControlOver } from '../components';
import { useControlOver } from '../hooks';
import { useOnboardingContext } from '../hooks/useOnboardingContext';
import { PageComponentProps } from '../types';

export const ControlOverStep = ({ canGoBack }: PageComponentProps) => {
  const { goToBack, initialValues, onSubmit, submitLoading } = useControlOver();

  const { step } = useOnboardingContext();

  const isGlobal = isGlobalProject();
  const isFinance = isFinanceProject();

  return (
    <ControlOver
      canGoBack={canGoBack}
      enabledControlOverLegalClientStatus={isGlobal}
      enabledFinancialConditionAmount={isFinance}
      enabledHasControlOverLegalClient={isFinance}
      initialValues={initialValues}
      step={step}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
